import React, { useEffect, useState } from 'react'
import { FiArrowUp } from 'react-icons/fi'

export default function BackToTopButton() {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY
      setIsVisible(scrolled > 200)
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
  
  return (
    isVisible && (
      <div className="!z-5 absolute bottom-4 right-4">
        <button
          onClick={() => {
            window.scrollTo(0, 0) // Scroll to the top of the page
          }}
          className="border-2 border-secondary-600 bg-secondary-600/60 p-2 text-white hover:bg-secondary-600"
        >
          <FiArrowUp size={28} />
        </button>
      </div>
    )
  )
}
